import { render, staticRenderFns } from "./ChangePasswordSuccess.vue?vue&type=template&id=540db5d6&"
import script from "./ChangePasswordSuccess.vue?vue&type=script&lang=ts&"
export * from "./ChangePasswordSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePasswordSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports